import { jsx as _jsx } from "react/jsx-runtime";
import { Box, LinearProgress } from '@mui/material';
export const Loader = ({ className }) => (_jsx(Box, { my: 2, width: "100%", className: className, "data-test": "container:loader", children: _jsx(LinearProgress, { color: "primary" }, void 0) }, void 0));
//# sourceMappingURL=Loader.js.map